export default "__VITE_ASSET__BCV4Iw2i__"